import { render, staticRenderFns } from "./ListaDestinatario.vue?vue&type=template&id=2cdd6c80&"
import script from "./ListaDestinatario.vue?vue&type=script&lang=js&"
export * from "./ListaDestinatario.vue?vue&type=script&lang=js&"
import style0 from "./ListaDestinatario.vue?vue&type=style&index=0&id=2cdd6c80&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports